module.exports = __webpack_public_path__ + "img/embedded4.1f299936.png";